import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/ecommerce_web/why_choose_ecomm.webp";

function Whychooseecommerce() {
  return (
    <section
      className="trusted_ecommerce_web ecommerce_why_choose p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2 style={{ color: "#fff" }}>
              Why Choose TekRevol as Your eCommerce Web Development Company?
            </h2>
            <Link
              style={{ background: "#f47a1f", color: "#fff" }}
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Start eCommerce Web Development
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-3 mt-md-0">
            <p style={{ color: "#fff" }}>
              An eCommerce website is your digital storefront, where every
              interaction counts. A well-designed and optimized eCommerce site
              not only attracts visitors but converts them into loyal customers.
              Our eCommerce website development services are designed to
              maximize your business potential and drive measurable results.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row className="mt-3 mt-md-5">
              <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">01</div>
                  <div className="ecomm_box_content">
                    <h5>
                      Enhanced User
                      <br />
                      Experience
                    </h5>
                    <p>
                      Deliver a smooth and intuitive shopping journey,
                      increasing customer satisfaction and loyalty.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">02</div>
                  <div className="ecomm_box_content">
                    <h5>
                      Higher Conversion
                      <br /> Rates
                    </h5>
                    <p>
                      Optimize every element to turn visitors into buyers,
                      maximizing your revenue.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">03</div>
                  <div className="ecomm_box_content">
                    <h5>
                      Efficient Inventory
                      <br /> Management
                    </h5>
                    <p>
                      Integrate smart systems for real-time inventory tracking
                      and management.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">04</div>
                  <div className="ecomm_box_content">
                    <h5>
                      Advanced SEO
                      <br /> Strategies
                    </h5>
                    <p>
                      Drive organic traffic with targeted SEO techniques,
                      boosting your online visibility.
                    </p>
                  </div>
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={3}
                xxl={3}
                className="mb-xl-0 mb-4"
              >
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">05</div>
                  <div className="ecomm_box_content">
                    <h5>
                      Fast Load
                      <br /> Times
                    </h5>
                    <p>
                      Ensure quick page loads to keep customers engaged and
                      reduce bounce rates.
                    </p>
                  </div>
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={3}
                xxl={3}
                className="mb-xl-0 mb-4"
              >
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">06</div>
                  <div className="ecomm_box_content">
                    <h5>
                      Personalized
                      <br /> Shopping
                    </h5>
                    <p>
                      Implement AI-driven recommendations to enhance the
                      shopping experience.
                    </p>
                  </div>
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={3}
                xxl={3}
                className="mb-4 mb-md-0"
              >
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">07</div>
                  <div className="ecomm_box_content">
                    <h5>
                      Seamless
                      <br /> Integrations
                    </h5>
                    <p>
                      Easily connect with third-party tools and services for a
                      comprehensive eCommerce solution.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">08</div>
                  <div className="ecomm_box_content">
                    <h5>
                      Recover Abandoned
                      <br /> Sales
                    </h5>
                    <p>
                      Reduce cart abandonment and recover lost sales to boost
                      your revenue potential.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whychooseecommerce;
